import _ from "lodash";
import { useApi } from "../../../../utils/hooks";
import TemplateDialog from "./TemplateDialog";
import { toHydratedItems } from "./utils";

const TemplateCreator = ({ templates, setTemplates, ...props }) => {
  const title = "Nueva plantilla";
  const buttonText = "Crear";
  const api = useApi();

  const addToTemplates = (template) =>
    setTemplates((prev) => [...prev, template]);
  // La API devuelve la entidad cruda (`content`, sin `items`); el resto de la UI
  // (buscador, editar, aplicar plantilla) espera la forma hidratada de GET
  // (`items`, sin `content`). Se arma acá con los mismos `selectedItems` ya
  // usados para construir el DTO, sin otro round-trip contra la API.
  const createTemplate = ({ type, templateDto, selectedItems }) =>
    api
      .createTemplate(type, templateDto)
      .then((template) => ({ ..._.omit(template, "content"), items: toHydratedItems(selectedItems) }))
      .tap(addToTemplates);

  return (
    <TemplateDialog
      onSubmit={createTemplate}
      title={title}
      buttonText={buttonText}
      {...props}
    />
  );
};

export default TemplateCreator;
